import store from '../../../admin/store'
import { SET_IMAGE_CROPPER } from '../../../admin/reducers/image-cropper'
import i18n from '../../../locales/i18n'
import { readFile } from './helpers'
import resizeImage from './resize-image'

/**
 * On file change and file is valid, set store
 *
 * @param {SyncEvent} event
 * @return {Promise<void>}
 */
export const onFileChange = async event => {
    if ((event?.target?.files?.length || 0) === 0) {
        return
    }

    const file = event.target.files[0]

    if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        window.swalert(i18n.t('imageUpload.validationError'))

        store.dispatch({
            type: SET_IMAGE_CROPPER,
            data: {
                error: i18n.t('imageUpload.validationError'),
            },
        })

        return
    }

    readFile(file).then(imageFile => (
        resizeImage(imageFile).then(image => {
            store.dispatch({
                type: SET_IMAGE_CROPPER,
                data: {
                    imageSrc: image,
                    crop: {
                        x: 0,
                        y: 0,
                    },
                    zoom: 1,
                },
            })
        })
    ))
}
